import { fromIso8601DateTime } from "@/shared/lib/datetime";
import type { FreightMatching } from "@x-mile/api-contract";
import { addDays } from "date-fns";

export const calculateDeliveryProposalResponseDeadlineAt = (
  deliveryProposalOfferCargo: Pick<
    FreightMatching.schemas.OfferCargo,
    "createdAt"
  >,
) => {
  return addDays(fromIso8601DateTime(deliveryProposalOfferCargo.createdAt), 1);
};
